import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BehaviorSubject } from 'rxjs';

import {
  GeaMesCognitoModule,
  GeaMesAuthInterceptor,
  COGNITO_CONFIG_HA,
  APPLICATION_NAME,
  ALLOW_SCREENAUTH,
  APIGATEWAY_CONFIG
} from '@gea-mes/cognito';

import {
  GEA_MES_NAVBAR_APPLICATION_NAME,
  GEA_MES_NAVBAR_MENU_SERVICE,
  GEA_MES_NAVBAR_ENV_PROD_STATUS,
  GEA_ENVIROMENT,
  NavItem
} from '@gea-mes/navbar';

import { MarkdownModule } from 'ngx-markdown';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

import { environment } from 'src/environments/environment';
import { appinfo } from './appinfo';
import { TimeFormatPipe } from './pipes/time-format.pipe';
import { NgxDaterangepickerMd, LocaleService } from 'ngx-daterangepicker-material';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideEchartsCore({ echarts }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),

    importProvidersFrom(
      GeaMesCognitoModule,
      MarkdownModule.forRoot(),
      NgxDaterangepickerMd.forRoot()
    ),
    LocaleService,
    TimeFormatPipe,

    { provide: COGNITO_CONFIG_HA, useValue: environment.cognitoOptionsHA },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: GeaMesAuthInterceptor, multi: true },
    { provide: APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: APIGATEWAY_CONFIG, useValue: environment.apiGateway },
    { provide: ALLOW_SCREENAUTH, useValue: environment.AllowScreenAuth },

    { provide: GEA_MES_NAVBAR_APPLICATION_NAME, useValue: appinfo.name.toUpperCase() },
    { provide: GEA_MES_NAVBAR_ENV_PROD_STATUS, useValue: environment.production },
    { provide: GEA_ENVIROMENT, useValue: environment },
    { provide: GEA_MES_NAVBAR_MENU_SERVICE, useValue: new BehaviorSubject<NavItem[]>([]) }
  ]
};